import { render } from "./AddEditShowSlideOver.vue?vue&type=template&id=06529016"
import script from "./AddEditShowSlideOver.vue?vue&type=script&lang=ts"
export * from "./AddEditShowSlideOver.vue?vue&type=script&lang=ts"
script.render = render

export default script